import type { FilterOption } from '@/components/ui/Filter';

export const buildPatientFilters = (
	clubs: Clubs.Club[],
	companies: Companies.Company[] = [],
): Array<FilterOption> => {
	const base: Array<FilterOption> = [
		{
			type: 'banned',
			label: 'Status',
			options: [
				{ value: 'false', label: 'Ativo' },
				{ value: 'true', label: 'Banido' },
			],
		},
		{
			type: 'is_complete',
			label: 'Estado do cadastro',
			options: [
				{ value: 'true', label: 'Completo' },
				{ value: 'false', label: 'Incompleto' },
			],
		},
	];
	if (clubs.length > 0) {
		base.push({
			type: 'club_id',
			label: 'Clube',
			options: clubs.map((c) => ({ value: c.id, label: c.name })),
		});
	}
	if (companies.length > 0) {
		base.push({
			type: 'company_id',
			label: 'Empresa',
			options: companies.map((c) => ({
				value: c.id,
				label: c.trade_name || c.legal_name || 'Empresa sem nome',
			})),
		});
	}
	return base;
};
